module.exports = __webpack_public_path__ + "static/img/partner-leverstyle.7dd7c89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-leverstyle.png
// module id = IHoS
// module chunks = 34